import {
  computed,
  nextTick, ref, set,
} from '@vue/composition-api'
import {
  isEmpty, isArray,
  cloneDeep,
} from 'lodash-es'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'

import { apiBooking } from '@/api'
import { convertISODateTime } from '@/@core/utils/filter'
import { isDomesticFlight } from '@/constants/selectOptions'
import store from '@/store'
import { getUserData } from '@/api/auth/utils'
import formValidation from '@/@core/comp-functions/forms/form-validation'

import useToast from '@useToast'

const blankPax = {
  isSetBirthday: false,
  paxId: '1',
  firstName: '',
  lastName: '',
  title: '',
  birthday: '',
  paxType: '',
  infPaxId: undefined,
  parentPaxId: undefined,
}

const tripTabIndex = ref(0)
const loadingSearch = ref(false)
const loadingCalculatePrice = ref(false)

const currency = ref('VND')
const fareType = ref(null)
const isBargainFinder = ref(true)
const keepGroup = ref(true)
const retain = ref(true)

const resultCalculatePrice = ref(null)
const resultCreatedBooking = ref(null)

let paxIdCount = 0

const resultTrip = ref([])
const selectedTrips = ref([])
const passengerLists = ref([])

const paxCount = paxType => passengerLists.value.filter(p => p.paxType === paxType).length

const adultCount = computed(() => paxCount('ADULT'))
const childCount = computed(() => paxCount('CHILD'))
const infantCount = computed(() => paxCount('INFANT'))

const { refFormObserver: refFormPassengerObserver, getValidationState } = formValidation()

function reset() {
  paxIdCount = 0
  resultTrip.value.splice(0)
  selectedTrips.value.splice(0)
  passengerLists.value.splice(0)
}

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

function getDataPax(paxType, length) {
  return Array.from({ length }, () => {
    const paxId = `${paxIdCount += 1}`
    return {
      ...blankPax,
      PaxDocuments: [
        {
          paxId,
          docType: 'P',
          number: '',
          nationality: '',
          residence: '2023-06-16',
          issCountry: '',
          startDate: '',
          endDate: '',
          isCountry: '',
        },
      ],
      memberFly: [
        {
          airline: 'VN',
          cardNumber: null,
        },
      ],
      paxId,
      paxType,
      isSetBirthday: ['INFANT'].includes(paxType),
    }
  })
}

function sortPaxLists() {
  const order = { ADULT: 1, CHILD: 2, INFANT: 3 }
  passengerLists.value.sort((a, b) => {
    if (order[a.paxType] < order[b.paxType]) return -1
    if (order[a.paxType] > order[b.paxType]) return 1
    return 0
  })
  console.log('RUN SORT zzz')
}

function handleUpdateInfPaxId(adtPaxId, infPaxId) {
  set(passengerLists.value[passengerLists.value.findIndex(p => p.paxId === adtPaxId)], 'infPaxId', infPaxId)
}

function setQuantityPax(data) { // Init pax lần với data search ( ClassBookingPro.vue )
  const result = []
  const { adult: adultCount, child: childCount, infant: infantCount } = data
  if (adultCount) {
    const adults = getDataPax('ADULT', adultCount)
    result.push(...adults)
  }
  if (infantCount) {
    const infants = getDataPax('INFANT', infantCount)
    infants.forEach(inf => {
      const firstAdtNoInfIndex = result.findIndex(adt => !adt.infPaxId)
      inf.parentPaxId = result[firstAdtNoInfIndex].paxId
      result[firstAdtNoInfIndex].infPaxId = inf.paxId
    })
    result.push(...infants)
  }
  if (childCount) {
    const childs = getDataPax('CHILD', childCount)
    result.push(...childs)
  }
  passengerLists.value.push(...result)
  nextTick(() => {
    sortPaxLists()
  })
}

function updatePaxCount(paxType, count) {
  const currentCount = paxCount(paxType)
  if (currentCount === count) return
  if (currentCount < count) { // THÊM
    const newPaxs = getDataPax(paxType, count - currentCount)
    if (paxType === 'INFANT') {
      newPaxs.forEach(inf => {
        const firstAdtNoInfIndex = passengerLists.value.findIndex(adt => !adt.infPaxId)
        inf.parentPaxId = passengerLists.value[firstAdtNoInfIndex].paxId
        set(passengerLists.value[firstAdtNoInfIndex], 'infPaxId', inf.paxId)
      })
    }
    passengerLists.value.push(...newPaxs)
  } else { // XOÁ
    const deleteCount = currentCount - count
    const deleteItems = passengerLists.value.filter(pax => pax.paxType === paxType).slice(-deleteCount)

    if (['ADULT'].includes(paxType)) {
      const action = {
        deletePaxIds: [],
        update: [],
      }

      const currentCountINF = paxCount('INFANT')

      if (currentCountINF > count) {
        const deleteINFCount = currentCountINF - count
        const infantDels = passengerLists.value.filter(pax => pax.paxType === 'INFANT').slice(-deleteINFCount)

        infantDels.forEach(inf => {
          action.deletePaxIds.push(inf.paxId)

          if (deleteItems.findIndex(adt => adt.infPaxId === inf.paxId) === -1) {
            action.update.push({
              paxId: passengerLists.value.find(adt => adt.paxId === inf.parentPaxId).paxId,
              key: 'infPaxId',
              value: undefined,
            })
          }
        })
      }

      deleteItems.forEach(adt => {
        action.deletePaxIds.push(adt.paxId)
        if (adt.infPaxId && !action.deletePaxIds.find(id => id === adt.infPaxId)) {
          action.update.push({
            paxId: passengerLists.value.find(inf => inf.paxId === adt.infPaxId).paxId,
            key: 'parentPaxId',
            value: undefined,
          })
        }
      })

      const newList = cloneDeep(passengerLists.value.filter(pax => !action.deletePaxIds.some(id => id === pax.paxId)))

      action.update.forEach(ac => {
        newList[newList.findIndex(p => p.paxId === ac.paxId)][ac.key] = ac.value
      })

      passengerLists.value = newList
      return
    }

    if (['INFANT'].includes(paxType)) {
      deleteItems.forEach(inf => {
        const fareWellParent = passengerLists.value.findIndex(p => p.paxId === inf.parentPaxId)
        if (fareWellParent !== -1) set(passengerLists.value[fareWellParent], 'infPaxId', undefined)
      })
    }

    passengerLists.value = cloneDeep(passengerLists.value.filter(pax => !deleteItems.some(p => p.paxId === pax.paxId)))
  }

  nextTick(() => {
    sortPaxLists()
  })
}

function deletePaxHandle(pax) { // mặc định số pax adt === inf => !!adt.infPaxId
  if (pax.paxType === 'ADULT') {
    if (pax.infPaxId) {
      const currentCountINF = paxCount('INFANT')
      const currentCountADT = paxCount('ADULT')
      if (currentCountADT - 1 >= currentCountINF) {
        set(passengerLists.value[passengerLists.value.findIndex(p => p.paxId === pax.infPaxId)], 'parentPaxId', undefined)
      } else {
        passengerLists.value.splice(passengerLists.value.findIndex(p => p.paxId === pax.infPaxId), 1)
      }
    }
  }

  if (pax.paxType === 'INFANT') {
    set(passengerLists.value[passengerLists.value.findIndex(p => p.paxId === pax.parentPaxId)], 'infPaxId', undefined)
  }

  passengerLists.value.splice(passengerLists.value.findIndex(p => p.paxId === pax.paxId), 1)
}

function getSearchFlightArray(req) {
  if ((req.flights?.length > 1 && req.type === 'MC') || (req.type === 'OW')) {
    return [...req.flights]
  }

  const result = []
  if (req.type === 'RT') {
    result.push({
      startPoint: req.flights[0].startPoint,
      endPoint: req.flights[0].endPoint,
      departDate: req.flights[0].departDate,
    })

    if (req.flights?.length === 1) {
      result.push({
        startPoint: req.flights[0].endPoint,
        endPoint: req.flights[0].startPoint,
        departDate: req.flights[0].returnDate,
      })
    } else {
      result.push({
        startPoint: req.flights[1].endPoint,
        endPoint: req.flights[1].startPoint,
        departDate: req.flights[1].departDate,
      })
    }
  }
  return result
}

function getSortTripBySegment(segment, isSelected = false) {
  const {
    departure, arrival, departureDate, departureTimezone, arrivalDate, arrivalTimezone, airline, flightNumber, airCraft, operating, bookingClass,
  } = segment

  const getDepartureTime = departureDate && departureTimezone ? convertISODateTime(departureDate, departureTimezone).hourMin : ''
  const getArrivalTime = arrivalDate && arrivalTimezone ? convertISODateTime(arrivalDate, arrivalTimezone).hourMin : ''
  const getDepartureDayAndMonth = departureDate && departureTimezone ? convertISODateTime(departureDate, departureTimezone).dayMonth : ''
  const getAirline = airline || ''
  const getFlightNumber = flightNumber || ''
  const getDeparture = departure || ''
  const getArrival = arrival || ''
  const getAirCraft = airCraft || ''
  const getOperating = operating || ''
  const getBookingStatus = ['LL'].includes(bookingClass?.status) ? 'HL' : ['NN'].includes(bookingClass?.status) ? `${bookingClass?.status}${bookingClass?.availability}` : (bookingClass?.status || '')
  const getBookingCode = bookingClass?.code || ''

  return isSelected // dùng với key value-input: trong div chưa tăng được space
    ? `${getAirline}${getFlightNumber} ${getBookingCode} ${getDepartureDayAndMonth} ${getDeparture}${getArrival} ${getBookingStatus} ${getDepartureTime} ${getArrivalTime} ${getAirCraft}`
    : `${getOperating ? `${getOperating}* ` : ''}${getAirline}${getFlightNumber} ${getDepartureDayAndMonth} ${getDeparture}${getArrival} ${getDepartureTime} ${getArrivalTime} ${getAirCraft}`
}

function deleteItineraryFromResultHandle(id) {
  resultTrip.value.splice(resultTrip.value.findIndex(trip => trip.id === id), 1)
}

function deleteTripHandle(selectedTripId) {
  selectedTrips.value.splice(selectedTrips.value.findIndex(trip => trip.selectedTripId === selectedTripId), 1)
}

function hasDuplicateTrip(tripList) {
  const seenTripIds = new Set()
  for (const { tripId } of tripList) {
    if (seenTripIds.has(tripId)) return true
    seenTripIds.add(tripId)
  }
  return false
}

const getShortSegment = (segment, isConvertTime = false) => {
  const result = `${segment.flightNumber}${segment.departure}${segment.arrival}${isConvertTime ? convertISODateTime(segment.departureDate, segment.departureTimezone).ISOdatetime.split('T')[0] : segment.departureDate.split('T')[0]}${segment.departureTimezone}`
  return result
}

function updateNewClassFromCalculate(checkedList, calculatedTripList) {
  const checkedTripList = cloneDeep(checkedList)
  calculatedTripList.forEach(newSegment => {
    const indexCheckedTrip = checkedTripList.findIndex(checkedTrip => checkedTrip.segments.some(checkedSegment => getShortSegment(checkedSegment, true) === getShortSegment(newSegment)))
    let indexCheckedSegment = -1
    if (indexCheckedTrip !== -1) {
      indexCheckedSegment = checkedTripList[indexCheckedTrip].segments.findIndex(checkedSegment => getShortSegment(checkedSegment, true) === getShortSegment(newSegment))
    }
    if ((indexCheckedTrip !== -1) && (indexCheckedSegment !== -1)) {
      const segmentClass = checkedTripList[indexCheckedTrip].segments[indexCheckedSegment].bookingClass
      if (segmentClass.code !== newSegment.bookingClass) {
        segmentClass.changed = true
        segmentClass.code = newSegment.bookingClass
      }
    }
  })
  checkedTripList.forEach(checkedTrip => {
    const indexModify = selectedTrips.value.findIndex(trip => trip.selectedTripId === checkedTrip.selectedTripId)
    if (indexModify !== -1) set(selectedTrips.value, indexModify, checkedTrip)
  })
}

export default function useClassBookingPro() {
  const { toastError, toastSuccess } = useToast()

  function selectTripHandle(bookingClass, trip) {
    /*
      - Chỉ chọn class ở segment 0.
      - Tự fill các segment còn lại với bookingClass đã chọn, nếu các segment còn lại không có thì return err.
      - Check chọn trùng chặng và hạng đặt chỗ.
    */

    const hasClassSelected = !isEmpty(selectedTrips.value)
                          && selectedTrips.value.some(it => it.segments[0].departure === trip.segments[0].departure
                                                           && it.segments[0].arrival === trip.segments[0].arrival
                                                           && it.segments[0].flightNumber === trip.segments[0].flightNumber
                                                           && it.segments[0].departureDate === trip.segments[0].departureDate
                                                           && it.segments[0].bookingClass.code === bookingClass.code)

    if (hasClassSelected) {
      toastError({ title: 'Lỗi chọn trùng chặng bay và hạng đặt chỗ !' })
      return
    }

    const segmentSelect = []
    const isValidClasses = trip.segments.every(segment => segment.bookingClassAvail.some(bClass => bookingClass.code === bClass.code))
    if (!isValidClasses) {
      toastError({ content: 'Hạng vé đã chọn không có sẵn trên chặng bay hiện tại, vui lòng chọn lại!' })
      return
    }

    trip.segments.forEach(segment => {
      const { bookingClassAvail, ...rest } = segment
      const data = {
        ...rest,
        bookingClass: bookingClassAvail.find(bClass => bClass.code === bookingClass.code),
      }
      segmentSelect.push(data)
    })

    selectedTrips.value.push({
      isChecked: true,
      tripId: trip.tripId,
      selectedTripId: uuidv4(),
      segments: segmentSelect,
    })

    selectedTrips.value.sort((tripA, tripB) => { // sort selected trip when add by segment[0].departure time & timezone
      const segA = tripA.segments[0]
      const segB = tripB.segments[0]
      const timeA = moment.utc(segA.departureDate).utcOffset(segA.departureTimezone).valueOf() // -> timestamp
      const timeB = moment.utc(segB.departureDate).utcOffset(segB.departureTimezone).valueOf() // -> timestamp
      return timeA - timeB
    })
  }

  async function searchClassBooking(payload) {
    try {
      const { req, isGlobalSearch = false, isAddNewTab = false } = payload

      if (!req.airline) {
        req.airline = req.airlines[0]
      }
      if (isArray(req.airline)) {
        req.airline = req.airline[0]
      }
      if (req.type === 'RT' && req.flights.length > 1) {
        req.flights = req.flights.slice(0, 1)
      }

      if (isEmpty(req?.permittedCarriers)) {
        req.permittedCarriers = undefined
      }

      loadingSearch.value = true

      const res = await apiBooking.searchClassBooking(req)

      // await delay(500)
      // const res = fakeData

      if (isEmpty(res)) {
        return
      }
      const searchFlightArr = getSearchFlightArray(req)

      if (isGlobalSearch) {
        resultTrip.value = res.map((it, index) => {
          const name = `${searchFlightArr[index].startPoint}-${searchFlightArr[index].endPoint} ${convertISODateTime(searchFlightArr[index].departDate).dayAndMonth}`
          return {
            id: uuidv4(),
            name,
            items: it.trips.map(trip => ({ ...trip, tripId: uuidv4() })),
          }
        })
      }

      const data = {
        id: uuidv4(),
        name: `${searchFlightArr[0].startPoint}-${searchFlightArr[0].endPoint} ${convertISODateTime(searchFlightArr[0].departDate).dayAndMonth}`,
        items: res[0].trips.map(trip => ({ ...trip, tripId: uuidv4() })),
      }

      if (isAddNewTab) {
        resultTrip.value.push(data)
        return
      }

      set(resultTrip.value, resultTrip.value.length - 1, data)
    } catch (error) {
      console.error('error searchClassBooking: ', error)
    } finally {
      loadingSearch.value = false
    }
  }

  const createTripElement = trip => ({
    source: 'VN1A',
    airline: trip.segments[0]?.airline,
    clientId: '',
    bookingKey: '',
    fareBreakdowns: [],
    segments: trip.segments.map((seg, segIndex) => ({
      leg: seg.leg || segIndex,
      airline: seg.airline,
      departure: seg.departure,
      arrival: seg.arrival,
      departureTime: convertISODateTime(seg.departureDate, seg.departureTimezone).ISOdatetime,
      arrivalTime: convertISODateTime(seg.arrivalDate, seg.arrivalTimezone).ISOdatetime,
      flightNumber: seg.flightNumber ? String(seg.flightNumber) : '',
      fareType: '',
      fareBasisCode: '',
      bookingClass: seg?.bookingClass?.code || '',
      groupClass: seg?.bookingClass?.groupClass || '',
      marriageGrp: '',
      segmentValue: seg?.segmentValue || '',
      segmentId: '',
      status: seg?.bookingClass?.status || '',
    })),
  })

  async function calculatePriceHandle() {
    const checkedTripList = selectedTrips.value.filter(trip => trip.isChecked)

    if (isEmpty(checkedTripList)) {
      toastError({ title: 'Vui lòng chọn hành trình!' })
      return
    }
    const isStatusHLDSChecked = checkedTripList.some(trip => trip.segments.some(seg => seg.bookingClass.status !== 'NN'))
    if (isStatusHLDSChecked) {
      toastError({ title: 'Vui lòng bỏ chuyến bay có tình trạng HL,DS ra khỏi danh sách tính giá !' })
      return
    }
    const isCheckedDuplicateTrip = hasDuplicateTrip(checkedTripList)
    if (isCheckedDuplicateTrip) {
      toastError({ title: 'Không thể chọn trùng chuyến bay để tính giá, vui lòng kiểm tra lại hành trình đã chọn !' })
      return
    }

    resultCalculatePrice.value = null

    const passengerTypeRequests = passengerLists.value.reduce((acc, { paxType }) => {
      const paxTypeItem = acc.find(el => el.code === paxType)
      // eslint-disable-next-line no-unused-expressions
      paxTypeItem ? (paxTypeItem.quantity += 1) : acc.push({ code: paxType, quantity: 1 })
      return acc
    }, [])

    const tripEle = checkedTripList.map(trip => createTripElement(trip))

    const req = {
      contact: getUserData().employeeData.id,
      agencyCode: getUserData().employeeData?.agency?.agencyCode,
      paxCode: '',
      tourCode: '',
      accountCode: '',
      bargainFinder: isBargainFinder.value,
      keepGroup: keepGroup.value,
      currency: currency.value,
      fareType: fareType.value ?? undefined,
      passengerTypeRequests,
      itineraries: tripEle,
      source: 'VN1A',
    }

    try {
      loadingCalculatePrice.value = true
      const response = await store.dispatch('app-flight-v2/calculatePrice', req)
      if (isEmpty(response)) {
        toastError({ title: 'Lỗi tính giá hành trình!' })
        return
      }

      const legTrip = req.itineraries.length
      const isDomestic = req.itineraries.every(trip => trip.segments.every(seg => isDomesticFlight(seg.departure, seg.departure)))
      const agencyFee = store.getters['userStore/getAgencyFee'](isDomestic, '1S')
      const hideFee = store.getters['userStore/getHideFee']
      const agencyFeeAmount = agencyFee?.amount || 0

      const data = response.map(paxPrices => {
        // const serviceFeePax = ['ADULT'].includes(paxPrices.fareInfos[0].paxType) ? serviceFeeAdult : ['CHILD'].includes(paxPrices.fareInfos[0].paxType) ? serviceFeeChild : serviceFeeInfant

        const quantityPax = req.passengerTypeRequests.find(p => p.code === paxPrices.fareInfos[0].paxType)?.quantity || 1
        const totalTaxes = paxPrices.totalTaxes + (hideFee ? agencyFeeAmount * legTrip : 0)
        const totalPrice = paxPrices.totalPrice + (hideFee ? agencyFeeAmount * legTrip : 0)
        const finalTotalTaxes = paxPrices.totalTaxes + (hideFee ? agencyFeeAmount * legTrip : 0) // NOTE: chỉ có phí ẩn F2>F3
        const finalTotalPrices = paxPrices.totalPrice + (hideFee ? agencyFeeAmount * legTrip : 0) // NOTE: chỉ có phí ẩn F2>F3

        return {
          ...paxPrices,
          totalTaxes,
          totalPrice,
          quantityPax,
          finalTotalTaxes,
          finalTotalPrices,
          currency: currency.value,
          bargainFinder: isBargainFinder.value,
          // serviceFeePax,
        }
      })

      resultCalculatePrice.value = data

      if (isBargainFinder.value) {
        updateNewClassFromCalculate(checkedTripList, data[0].bookingInfos)
      }
    } catch (error) {
      console.error('Error submitRecalculatePrice:', error)
    } finally {
      loadingCalculatePrice.value = false
    }
  }

  async function createBooking(payload) {
    // loadingSearch.value = true

    try {
      const { resBooking } = await apiBooking.commandCreateBooking(payload)
      resultCreatedBooking.value = resBooking
      toastSuccess({ title: 'messagesList.success', content: 'Đặt giữ chỗ thành công!' })
    } catch (error) {
      console.error('Error create booking: ', error)
      toastError({ title: 'messagesList.error', content: error.message })
    } finally {
      // loadingSearch.value = false
    }
  }

  function updateTripTabIndex(index) {
    tripTabIndex.value = index
  }

  return {
    // ===== OutSide =====
    tripTabIndex,
    loadingSearch,
    loadingCalculatePrice,
    currency,
    fareType,
    isBargainFinder,
    retain,
    keepGroup,
    resultTrip,
    selectedTrips,
    passengerLists,
    resultCalculatePrice,
    adultCount,
    childCount,
    infantCount,
    refFormPassengerObserver,
    resultCreatedBooking,
    getValidationState,
    reset,
    deleteItineraryFromResultHandle,
    deleteTripHandle,
    setQuantityPax,
    paxCount,
    updatePaxCount,
    getSortTripBySegment,
    deletePaxHandle,
    handleUpdateInfPaxId,

    // ===== Inside =====
    selectTripHandle,
    searchClassBooking,
    calculatePriceHandle,
    createBooking,
    updateTripTabIndex,
  }
}
